import React, { memo, useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import cls from './EstimateMeasurementsModalSelect.module.css';
import { Select } from '../../../../components/newUI/Select/Select';
import { EstimateMeasurementsContext } from '../../Context/EstimateMeasurementsContext';
import { getMeasurement } from '../../../../store/slices/measurementsSlice/action';
import {
    getFromLocalStorage,
    saveToLocalStorage,
} from '../../../../shared/helpers/localStorageHandler';

export const EstimateMeasurementsModalSelect = memo(() => {
    const dispatch = useDispatch();
    const { optionsList } = useContext(EstimateMeasurementsContext);
    const [selected, setSelected] = useState(optionsList[0]);
    useEffect(() => {
        const idMeasurement = getFromLocalStorage('idMeasurement');
        if (idMeasurement) {
            const selectedOption = optionsList.find((option) => option.value === idMeasurement);
            if (selectedOption) {
                setSelected(selectedOption);
            } else {
                setSelected(optionsList[0] || {});
            }
        } else {
            setSelected(optionsList[0] || {});
        }
    }, [optionsList]);

    const onSelect = useCallback(
        (value) => {
            const selectedOption = optionsList.find((option) => option.value === value);
            const localOption = getFromLocalStorage('idMeasurement');
            if (selectedOption) {
                if (localOption === value) {
                    return;
                }
                dispatch(getMeasurement(value));
                setSelected(selectedOption);
                saveToLocalStorage('idMeasurement', value);
            }
        },
        [optionsList]
    );
    return (
        <div className={cls.container}>
            <Select
                options={optionsList}
                title={''}
                selected={selected}
                onChange={onSelect}
                classes={cls.select}
            />
        </div>
    );
});
